<template>
   <div id="content" class="section bg-transparent my-0 py-0" v-if="isApiCallInProgress">
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <div class="row border-between">
               <div class="col-lg-7 mb-5 mb-lg-0">
                  <div class="loading-placeholder" style="background-color: #e0e0e0; aspect-ratio: 16/9;"></div>
                  <div class="loading-placeholder" style="height: 2em; width: 60%; background-color: #e0e0e0; margin-top: 1em;"></div>
               </div>
               <div class="col-lg-5">
                  <h3 class="font-body fw-medium mb-4 h4">Recent Posts</h3>
                  <div class="row posts-md col-mb-30">
                     <article class="entry col-12" v-for="i in [1, 2, 3]" :key="i">
                        <div class="grid-inner row gutter-20">
                           <div class="col-md-4">
                              <a class="entry-image">
                                 <div class="loading-placeholder" style="background-color: #e0e0e0; aspect-ratio: 16/9;"></div>
                              </a>
                           </div>
                           <div class="col-md-8">
                              <div class="entry-title title-xs">
                                 <div class="entry-categories">
                                    <div class="loading-placeholder" style="height: 1.2em; width: 80%; background-color: #e0e0e0; margin-bottom: 1em;"></div>
                                 </div>
                                 <h3>
                                    <div class="loading-placeholder" style="height: 2em; width: 100%; background-color: #e0e0e0; margin-bottom: 1em;"></div>
                                 </h3>
                              </div>
                              <div class="entry-meta">
                                 <ul>
                                    <li>
                                       <a href="#">
                                          <div class="loading-placeholder" style="height: 1.2em; width: 60%; background-color: #e0e0e0;"></div>
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section bg-transparent my-0 py-0" v-else>
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <div class="row border-between">
               <div class="col-lg-7 mb-5 mb-lg-0">
                  <article class="entry border-bottom-0 mb-0">
                     <div class="entry-image">
                        <a :href='"/post/" + encodeURIComponent(recentPosts[0]?.attributes.slug)'>
                           <img
                              :src="getLargestMediaUrl(recentPosts[0]?.attributes.thumbnail.data)"
                              loading="lazy"
                              alt="Image 3"
                              class="image-preview"
                           >
                        </a>
                     </div>
                     <div class="entry-title">
                        <div class="entry-categories">
                           <a :href='"/post/category/" + recentPosts[0]?.attributes.category.data.attributes.name'>
                              {{ recentPosts[0]?.attributes.category.data.attributes.name }}
                           </a>
                        </div>
                        <h3>
                           <a
                              :href='"/post/" + encodeURIComponent(recentPosts[0]?.attributes.slug)'
                              class="stretched-link color-underline"
                           >
                              <span>
                                 {{ recentPosts[0]?.attributes.title }}
                              </span>
                           </a>
                        </h3>
                     </div>
                     <div class="entry-meta">
                        <ul>
                           <li>
                              <a href="#">
                                 {{ convertTimeToDate(recentPosts[0]?.attributes.createdAt) }}
                              </a>
                           </li>
                        </ul>
                     </div>
                     <div class="entry-content">
                        <p>
                           {{ recentPosts[0]?.attributes.description }}
                        </p>
                     </div>
                  </article>
               </div>
               <div class="col-lg-5">
                  <h3 class="font-body fw-medium mb-4 h4">Recent Posts</h3>
                  <div class="row posts-md col-mb-30">
                     <article class="entry col-12" v-for="post in recentPosts.slice(1, 5)" :key="post.id">
                        <div class="grid-inner row gutter-20">
                           <div class="col-md-4">
                              <a
                                 class="entry-image"
                                 :href='"/post/" + encodeURIComponent(post.attributes.slug)'
                              >
                                 <img :src="getLargestMediaUrl(post.attributes.thumbnail.data)" alt="Image">
                              </a>
                           </div>
                           <div class="col-md-8">
                              <div class="entry-title title-xs">
                                 <div class="entry-categories">
                                    <a :href='"/post/category/" + post.attributes.category.data.attributes.name'>
                                       {{ post.attributes.category.data.attributes.name }}
                                    </a>
                                 </div>
                                 <h3>
                                    <a
                                       :href='"/post/" + encodeURIComponent(post.attributes.slug)'
                                       class="stretched-link color-underline"
                                    >
                                       {{ post.attributes.title }}
                                    </a>
                                 </h3>
                              </div>
                              <div class="entry-meta">
                                 <ul>
                                    <li>
                                       <a href="#">
                                          {{ convertTimeToDate(post.attributes.createdAt) }}
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section dark my-0 py-0" v-if="isApiCallInProgress">
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <h2 class="font-body fw-medium">Popular</h2>
            <div class="row border-between">
               <div class="col-lg-7 mb-5 mb-lg-0">
                  <div class="loading-placeholder" style="background-color: #e0e0e0; aspect-ratio: 16/9;"></div>
                  <div class="loading-placeholder" style="height: 2em; width: 60%; background-color: #e0e0e0; margin-top: 1em;"></div>
               </div>
               <div class="col-lg-5">
                  <h3 class="font-body fw-medium mb-4 h4">Highlights</h3>
                  <div class="row posts-md col-mb-30">
                     <article class="entry col-12" v-for="i in [1, 2, 3]" :key="i">
                        <div class="grid-inner row gutter-20">
                           <div class="col-md-4">
                              <a class="entry-image">
                                 <div class="loading-placeholder" style="background-color: #e0e0e0; aspect-ratio: 16/9;"></div>
                              </a>
                           </div>
                           <div class="col-md-8">
                              <div class="entry-title title-xs">
                                 <div class="entry-categories">
                                    <div class="loading-placeholder" style="height: 1.2em; width: 80%; background-color: #e0e0e0; margin-bottom: 1em;"></div>
                                 </div>
                                 <h3>
                                    <div class="loading-placeholder" style="height: 2em; width: 100%; background-color: #e0e0e0; margin-bottom: 1em;"></div>
                                 </h3>
                              </div>
                              <div class="entry-meta">
                                 <ul>
                                    <li>
                                       <a href="#">
                                          <div class="loading-placeholder" style="height: 1.2em; width: 60%; background-color: #e0e0e0;"></div>
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section dark my-0 py-0" v-else>
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <h2 class="font-body fw-medium">Popular</h2>
            <div class="row border-between">
               <div class="col-lg-7 mb-5 mb-lg-0">
                  <article class="entry border-bottom-0 mb-0">
                     <div class="entry-image">
                        <a :href='"/post/" + encodeURIComponent(popularPosts[0]?.attributes.slug)'>
                           <img
                              :src="getLargestMediaUrl(popularPosts[0]?.attributes.thumbnail.data)"
                              loading="lazy"
                              alt="Image 3"
                              class="image-preview"
                           >
                        </a>
                     </div>
                     <div class="entry-title">
                        <div class="entry-categories">
                           <a :href='"/post/category/" + popularPosts[0]?.attributes.category.data.attributes.name'>
                              {{ popularPosts[0]?.attributes.category.data.attributes.name }}
                           </a>
                        </div>
                        <h3>
                           <a
                              :href='"/post/" + encodeURIComponent(popularPosts[0]?.attributes.slug)'
                              class="stretched-link color-underline"
                           >
                              <span>
                                 {{ popularPosts[0]?.attributes.title }}
                              </span>
                           </a>
                        </h3>
                     </div>
                     <div class="entry-meta">
                        <ul>
                           <li>
                              <a href="#">
                                 {{ convertTimeToDate(popularPosts[0]?.attributes.createdAt) }}
                              </a>
                           </li>
                        </ul>
                     </div>
                     <div class="entry-content">
                        <p>
                           {{ popularPosts[0]?.attributes.description }}
                        </p>
                     </div>
                  </article>
               </div>
               <div class="col-lg-5">
                  <h3 class="font-body fw-medium mb-4 h4">Highlights</h3>
                  <div class="row posts-md col-mb-30">
                     <article class="entry col-12" v-for="post in popularPosts.slice(1, 5)" :key="post.id">
                        <div class="grid-inner row gutter-20">
                           <div class="col-md-4">
                              <a
                                 class="entry-image"
                                 :href='"/post/" + encodeURIComponent(post.attributes.slug)'
                              >
                                 <img :src="getLargestMediaUrl(post.attributes.thumbnail.data)" alt="Image">
                              </a>
                           </div>
                           <div class="col-md-8">
                              <div class="entry-title title-xs">
                                 <div class="entry-categories">
                                    <a :href='"/post/category/" + post.attributes.category.data.attributes.name'>
                                       {{ post.attributes.category.data.attributes.name }}
                                    </a>
                                 </div>
                                 <h3>
                                    <a
                                       :href='"/post/" + encodeURIComponent(post.attributes.slug)'
                                       class="stretched-link color-underline"
                                    >
                                       {{ post.attributes.title }}
                                    </a>
                                 </h3>
                              </div>
                              <div class="entry-meta">
                                 <ul>
                                    <li>
                                       <a href="#">
                                          {{ convertTimeToDate(post.attributes.createdAt) }}
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </article>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section bg-transparent my-0 py-0">
      <div class="content-wrap pt-5" style="overflow: visible;">
         <div class="container">
            <div class="content-wrap">
               <div class="container mw-lg py-lg-5">
                  <div class="text-center mb-5 mb-lg-6">
                     <h2 class="display-5">Want To Get Involved?</h2>
                  </div>
                  <div class="clear"></div>
                  <div class="row grid-border justify-content-center mt-3">
                     <div class="col-lg-4 col-padding py-lg-0">
                        <h3 class="mb-1 fw-semibold">Become an Author</h3>
                        <p class="mb-5">Have something insightful, funny, or thought-provoking to share? Join our community of writers and publish your own articles.</p>
                        <div class="row flex-column gy-1 list-link">
                           <a href="/about#contact" class="fw-medium link-dark h-text-primary"><u>Submit Post</u></a>
                        </div>
                     </div>
                     <div class="col-lg-4 col-padding py-lg-0">
                        <h3 class="mb-1 fw-semibold">Community</h3>
                        <p class="mb-5">Engage with like-minded developers, share experiences, and contribute to discussions about whatever.</p>
                        <div class="row flex-column gy-1 list-link">
                           <a href="/community" class="mb-2 fw-medium link-dark h-text-primary"><u>Join the Community</u></a>
                        </div>
                     </div>
                     <div class="col-lg-4 col-padding py-lg-0">
                        <h3 class="mb-1 fw-semibold">Contact Us</h3>
                        <p class="mb-5">Have questions or feedback? Reach out to us—we’d love to hear from you!</p>
                        <div class="row flex-column gy-1 list-link">
                           <a href="/about#contact" class="mb-2 fw-medium link-dark h-text-primary"><u>Contact Us</u></a>
                           <a href="/about#contact" class="mb-2 fw-medium link-dark h-text-primary"><u>Report Content</u></a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="content" class="section bg-transparent my-0 py-0">
      <div class="content-wrap pt-5">
         <div class="container">
            <div class="container-fluid">
               <div class="row justify-content-center mx-auto mw-md gx-5">
                  <div class="col">
                     <p class="h6 mb-0">
                        This site and its community are designed for entertainment and engagement. While we strive for 
                        accuracy in our content, occasional errors may occur, and community contributions 
                        reflect individual opinions, not the views of the site.  If you have inquiries, wish to rectify misinformation, or 
                        seek clarification about our community, feel free to <a href="/about#contact">Contact Us</a>.
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { Post } from '@/models/Cms';
import { loadNewContent, loadPopularContent } from '@/utils/cms';
import { convertTimeToDate } from '@/utils/time';
import { APP_CONFIGS } from '@/main';
import { FrameControl } from '@/models/FrameControl';
import { Media } from '@/models/Cms';
import { getLargestMediaUrl } from '@/utils/cms';
import ArticlePreview from "@/components/post/ArticlePreview.vue";
import {
   emitPrerenderEvent,
   setPageMetaTags,
   detectPrerenderedPage,
   readRecentPostsFromPrerender,
   readPopularPostsFromPrerender,
   assignPrerenderData
} from '@/utils/seo';

@Options({
    components: {
        ArticlePreview,
    }
})
export default class DNDHome extends Vue {
 
   isApiCallInProgress = false;
   recentPosts: Post[] = [];
   popularPosts: Post[] = [];

   public async mounted(): Promise<void> {      
      // Set SEO meta tags
      setPageMetaTags(
         this.appConfigs.general.name,
         this.appConfigs.general.about,
         this.appConfigs.assets.logoImage,
         window.location.href,
      );

      if (!detectPrerenderedPage()) {
         try {
            // Load posts
            this.isApiCallInProgress = true;
            const [recentPosts, popularPosts] = await Promise.all([
               loadNewContent(5),
               loadPopularContent(5),
            ]);

            // Set post content and set pre-render
            this.recentPosts = recentPosts;
            this.popularPosts = popularPosts;
            assignPrerenderData({
               popularPosts: JSON.parse(JSON.stringify(this.popularPosts)),
               recentPosts: JSON.parse(JSON.stringify(this.recentPosts))
            });
         } catch (err) {
            console.error(err);
         } finally {
            this.isApiCallInProgress = false;
         }
      } else {
         // Load posts from pre-render
         const recentPosts = readRecentPostsFromPrerender();
         const popularPosts = readPopularPostsFromPrerender();

         // Set posts or fetch new ones
         if (recentPosts.length && popularPosts.length) {
            this.recentPosts = recentPosts;
            this.popularPosts = popularPosts;
         } else {
            const [recentPosts, popularPosts] = await Promise.all([
               loadNewContent(5),
               loadPopularContent(5),
            ]);

            // Reset post cache
            this.recentPosts = recentPosts;
            this.popularPosts = popularPosts;
            assignPrerenderData({
               popularPosts: JSON.parse(JSON.stringify(this.popularPosts)),
               recentPosts: JSON.parse(JSON.stringify(this.recentPosts))
            });
         }
      }

      // 🔔 Signal pre-render is ready
      emitPrerenderEvent();
   }

   getLargestMediaUrl(media: Media | undefined): string {
      if (media) {
         return getLargestMediaUrl(media);
      } else {
         return "";
      }
   }

   public convertTimeToDate(dateString: string): string {
      return convertTimeToDate(dateString);
   }
 
   get appConfigs(): FrameControl {
      return APP_CONFIGS;
   }
 
}
</script>
 
<style scoped>
.dark {
    background-color: #010101 !important;
}
.image-preview {
   width: 100%;
   object-fit: cover;
   object-position: center;
}
.loading-placeholder {
   animation: shimmer 1.5s infinite linear;
   background: #e0e0e0;
   border-radius: 4px;
}

@keyframes shimmer {
   0% {
      background-position: -200px 0;
   }
   100% {
      background-position: 200px 0;
   }
}
</style>